export const TIERS = {
  POOL: 'pool',
  CONSULTANT: 'consultant',
  ADVISER: 'adviser',
};

const POOL_EMAILS = new Set([
  'tech-integration@moneyfarm.com',
]);

const CONSULTANT_EMAILS = new Set([
  'waqar.unnisa@moneyfarm.com',
  'tom.biddle@moneyfarm.com',
  'justyna.janiczek@moneyfarm.com',
  'zaheer.ganchi@moneyfarm.com',
]);

const ADVISER_EMAILS = new Set([
  'paul.hepplestone@moneyfarm.com',
  'samantha.packham@moneyfarm.com',
  'richard.penney@moneyfarm.com',
  'ashleigh.ramsbottom@moneyfarm.com',
  'olivia.craig@moneyfarm.com',
  'josefine.jonsson@moneyfarm.com',
]);

export function tierFromEmail(email) {
  const e = String(email || '').trim().toLowerCase();
  if (POOL_EMAILS.has(e)) return TIERS.POOL;
  if (ADVISER_EMAILS.has(e)) return TIERS.ADVISER;
  if (CONSULTANT_EMAILS.has(e)) return TIERS.CONSULTANT;
  return TIERS.POOL;
}

export function titleForTier(tier) {
  switch (tier) {
    case TIERS.POOL:
      return 'Pension Experts';
    case TIERS.CONSULTANT:
      return 'Pension Expert';
    case TIERS.ADVISER:
      return 'Pension Adviser';
    default:
      return 'Pension Expert';
  }
}

export function pronouns(tier) {
  return tier === TIERS.POOL
    ? { subj: 'we', obj: 'us', poss: 'our' }
    : { subj: 'I', obj: 'me', poss: 'my' };
}
